var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14V9.2C2 7.29044 2.84285 5.45909 4.34315 4.10883C5.84344 2.75857 7.87827 2 10 2C12.1217 2 14.1566 2.75857 15.6569 4.10883C17.1571 5.45909 18 7.29044 18 9.2V14",
    stroke: "#26B0EB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12C18.5 11.7239 18.2761 11.5 18 11.5H15.5C14.9254 11.5 14.3743 11.7283 13.9679 12.1346C13.5616 12.5409 13.3333 13.092 13.3333 13.6667V16.1667C13.3333 16.7413 13.5616 17.2924 13.9679 17.6987C14.3743 18.1051 14.9254 18.3333 15.5 18.3333H16.3333C16.908 18.3333 17.4591 18.1051 17.8654 17.6987C18.2717 17.2924 18.5 16.7413 18.5 16.1667V12ZM2 11.5C1.72386 11.5 1.5 11.7239 1.5 12V16.1667C1.5 16.7413 1.72827 17.2924 2.1346 17.6987C2.54093 18.1051 3.09203 18.3333 3.66667 18.3333H4.5C5.07464 18.3333 5.62574 18.1051 6.03206 17.6987C6.43839 17.2924 6.66667 16.7413 6.66667 16.1667V13.6667C6.66667 13.092 6.43839 12.5409 6.03206 12.1346C5.62574 11.7283 5.07464 11.5 4.5 11.5H2Z",
    fill: "#26B0EB",
    stroke: "#26B0EB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/customerIcon.90f8c53ba92c7cedd6cdb3561b35e364.svg";
export { ForwardRef as ReactComponent };